import { Shop } from './../types/shop.type';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ShopService } from '../service/shop.service';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../user/services/user.service';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HistoryDialogComponent } from '../history-dialog/history-dialog.component';
import { DividerModule } from 'primeng/divider';
import { Util } from '../../../utils/util';
import { AddUserDialogComponent } from '../add-user-dialog/add-user-dialog.component';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { Aggregator } from '../types/aggregator';
import { User } from '../../user/models/user.type';
import { ClipboardModule } from 'ngx-clipboard';
import { Message } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-shop-detail',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    Tabs, TabList, Tab, TabPanels, TabPanel,
    TableModule,
    TagModule,
    ButtonModule,
    TooltipModule,
    DatePipe,
    TranslateModule,
    DialogModule,
    RadioButtonModule,
    InputNumberModule,
    ToastModule,
    SelectModule,
    DividerModule,
    ClipboardModule,
    Message,
    NgxPermissionsModule,
    ConfirmDialogModule,
  ],
  templateUrl: './shop-detail.component.html',
  styleUrl: './shop-detail.component.scss',
  providers: [TranslateService, MessageService, DialogService, ConfirmationService, NgxPermissionsService],
})
export class ShopDetailComponent implements OnInit {
  shopInfo: Shop;
  shopInfoEdit: Shop;
  users: any[] = [];
  headers: any[] = [
    {
      id: 'name',
      value: 'table.name',
    },
    {
      id: 'active',
      value: 'table.status',
      type: 'tag',
    },
    {
      id: 'email',
      value: 'Email',
    },
    {
      id: 'role',
      value: 'table.right',
    },
    {
      id: 'creationDate',
      value: 'table.accountCreation',
    },
    {
      id: 'modificationDate',
      value: 'table.lastModification',
    },
  ];
  headersAggregators = [
    {
      id: 'name',
      value: 'table.user',
    },
    {
      id: 'isAssociated',
      value: 'table.status',
      type: 'tag',
    },
    {
      id: 'activationDate',
      value: "table.activationDate",
    },
    {
      id: 'lastUsageDate',
      value: 'table.lastUse',
    },
  ];
  message = {
    detail: 'shop.message.detail',
    link: 'shop.message.link',
    severity: 'info',
  };
  scoreVisible = false;
  importVisible = false;
  scoreOutlined = true;
  user: User;
  shopCode;
  ref: DynamicDialogRef | undefined;
  importOutlined = true;
  selectedShop;
  showAssociateDialog = false;
  aggregators: Aggregator[] = [];
  allAggregators: Aggregator[] = [];

  showTooltip = false;
  isSeller;
  isOperatorAdmin;
  isSuperAdmin;
  relatedShops;
  selectedAggregator: Aggregator;
  showChangeAssociationDialog = false;
  activeTabIndex = 0;
  loading = false;

  @ViewChild('refValue') refValue: InputNumber;
  @ViewChild('mediaValue') mediaValue: InputNumber;
  @ViewChild('adValue') adValue: InputNumber;

  constructor(
    private readonly shopService: ShopService,
    public translate: TranslateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userService: UserService,
    private readonly messageService: MessageService,
    private readonly dialogService: DialogService,
    private readonly confirmationService: ConfirmationService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly permissionService: NgxPermissionsService,
  ) {}

  ngOnInit(): void {
    const viewAction =
      this.permissionService.getPermission('PERMISSION_MANAGE_USERS') ||
      this.permissionService.getPermission('PERMISSION_MANAGE_ROLES_AND_USERS') ||
      this.permissionService.getPermission('PERMISSION_SUPER_ADMIN');
    if (viewAction) {
      this.headers.push({
        id: 'actions',
        value: '',
        type: 'buttons',
        hidden: 'email',
      });
    }

    this.user = this.userService.getUser();
    this.isSeller = this.userService.isSeller();
    this.isOperatorAdmin = this.userService.hasRole(['ROLE_OPERATOR_ADMIN']);
    this.isSuperAdmin = this.userService.isSuperAdmin;
    this.loading = true;
    if (this.isSeller) {
      this.relatedShops = this.user.relatedShops;
      this.selectedShop = this.shopService.getSelectedShop();
      this.shopCode = this.selectedShop.shopCode;
      this.handleShopInfo(this.shopCode);
      this.initUserAggregators(this.selectedShop.shopCode);
    } else {
      this.activatedRoute.params.subscribe((params) => {
        this.shopCode = params['id'];
        this.handleShopInfo(this.shopCode);
        if(this.isSuperAdmin || this.isOperatorAdmin) {
          this.initUserAggregators(this.shopCode);
        }
      });
    }
  }

  initUserAggregators(shopCode: string) {
    this.shopService.getAggregatorByShopCode(shopCode).subscribe({
      next: (res: Aggregator[]) => {
        this.aggregators = res;
      },
    });
  }

  handleShopInfo(shopCode) {
    this.shopService.getShop(shopCode).subscribe({
      next: (res) => {
        this.users = [];
        this.shopInfo = res as Shop;
        this.selectedShop = this.shopInfo;
        this.shopInfoEdit = structuredClone(res) as Shop;
        this.shopInfo.channel = this.shopInfo.shopChannel.channelName;
        for (let user of this.shopInfo.shopUsers) {
          user.name = user.firstname + ' ' + user.lastname;
          if(user.defaultRole.roleCode != 'ROLE_ACCESS_APP') {
            user.role = user.defaultRole.roleName;
          }
          this.users.push(user);
        }
        this.loading = false;
        if (!this.isSeller) {
          this.relatedShops = [this.shopInfo];
        }
      },
    });
  }

  onShopChange(): void {
    this.shopCode = this.selectedShop.shopCode;
    if (this.selectedShop) {
      this.shopService.setSelectedShopCode(this.selectedShop.shopCode);
      this.handleShopInfo(this.selectedShop.shopCode);
      if (this.isSeller) {
        this.initUserAggregators(this.selectedShop.shopCode);
      }
    }
  }

  hideModalImport() {
    this.importOutlined = true;
    this.importVisible = false;
  }

  hideModalScore() {
    this.scoreVisible = false;
    this.shopInfoEdit =structuredClone(this.shopInfo);
  }

  submitImportForm() {
    let updateScore = false;
    const scoreAdToUpdate = this.shopInfo?.scoreAd == null
    const scoreMediaToUpdate = this.shopInfo?.scoreMedia == null
    const scoreRefToUpdate = this.shopInfo?.scoreRef == null
    if ((scoreAdToUpdate || scoreMediaToUpdate || scoreRefToUpdate) && !this.shopInfo?.shopCanImport) {
      updateScore = true;
      
    }
    this.shopInfo =structuredClone(this.shopInfoEdit);
    this.shopService
      .updateImport({
        email: this.user?.email,
        shopCode: this.shopInfo?.shopCode,
        shopCanImport: this.shopInfo?.shopCanImport,
      })
      .subscribe({
        next: () => {
          if (updateScore) {
            this.shopInfoEdit = {
              ...this.shopInfoEdit,
              scoreAd: scoreAdToUpdate ? 50 : this.shopInfo.scoreAd,
              scoreMedia: scoreMediaToUpdate ? 50 : this.shopInfo.scoreMedia,
              scoreRef: scoreRefToUpdate ? 50 : this.shopInfo.scoreRef,
            };
            this.shopInfo =structuredClone(this.shopInfoEdit);
            this.shopService
              .updateScore({
                email: this.user?.email,
                shopCode: this.shopInfo?.shopCode,
                scoreAd: scoreAdToUpdate ? 50 : this.shopInfo.scoreAd,
                scoreMedia: scoreMediaToUpdate ? 50 : this.shopInfo.scoreMedia,
                scoreRef: scoreRefToUpdate ? 50 : this.shopInfo.scoreRef,
              })
              .subscribe({
                next: () => {
                  this.showUpdateImportSuccessMessage()
                },
              })
          } else {
            this.showUpdateImportSuccessMessage()
          }
        },
      });

    this.importVisible = false;
  }

  showUpdateImportSuccessMessage() {
    this.messageService.add({
      severity: 'success',
      summary: 'Succès',
      detail: "Droit d'import mis à jour avec succès !",
    });
  }

  submitScoreForm() {
    const scoreAdUpdated = this.shopInfo.scoreAd == this.shopInfoEdit.scoreAd ? 0 : 1;
    const scoreMediaUpdated = this.shopInfo.scoreMedia == this.shopInfoEdit.scoreMedia ? 0 : 1;
    const scoreRefUpdated = this.shopInfo.scoreRef == this.shopInfoEdit.scoreRef ? 0 : 1;
    const updateLength = scoreAdUpdated + scoreMediaUpdated + scoreRefUpdated;
    this.shopInfo =structuredClone(this.shopInfoEdit);
    this.shopService
      .updateScore({
        email: this.user?.email,
        shopCode: this.shopInfo?.shopCode,
        scoreAd: this.shopInfo?.scoreAd,
        scoreMedia: this.shopInfo?.scoreMedia,
        scoreRef: this.shopInfo?.scoreRef,
      })
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail:
              updateLength > 1
                ? this.translate.instant('shop.scoreUpdateSuccess')
                : this.translate.instant('shop.scoreSingleUpdateSuccess'),
          });
        },
      });

    this.scoreVisible = false;
    this.scoreOutlined = true;
  }

  allowRange(event) {
    console.log(event)
  }

  scoreModelChange(type) {
    switch (type) {
      case 'scoreRef': {
        if (this.shopInfoEdit.scoreRef > 100) {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('messages.error'),
            detail: this.translate.instant('messages.scoreMax'),
          });
          this.shopInfoEdit.scoreRef = 100;
        }
        break;
      }
      case 'scoreMedia': {
        if (this.shopInfoEdit.scoreMedia > 100) {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('messages.error'),
            detail: this.translate.instant('messages.scoreMax'),
          });
          this.shopInfoEdit.scoreMedia = 100;
        }
        break;
      }
      case 'scoreAd': {
        if (this.shopInfoEdit.scoreAd > 100) {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('messages.error'),
            detail: this.translate.instant('messages.scoreMax'),
          });
          this.shopInfoEdit.scoreAd = 100;
        }
        break;
      }
    }
    this.scoreOutlined = false;
  }

  openHistoryDialog() {
    let type = ['shop', 'user'];
    if (this.activeTabIndex == 1) {
      type = ['aggregator_shop'];
    }
    this.ref = this.dialogService.open(HistoryDialogComponent, {
      header: this.translate.instant('shop.actionsHistory'),
      closable: true, 
      data: { shop: this.shopInfo, user: this.user, type: type, entityKey: this.shopCode },
      width: '65vw',
      height: '80vh',
      modal: true,
      breakpoints: {
        '1200px': '75vw',
        '960px': '80vw',
        '640px': '90vw',
      },
    });
  }

  addUser(data) {
    this.userService.createUser(data).subscribe({
      next: (message) => {
        if (message['success']) {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('messages.success'),
            detail: this.translate.instant('messages.userCreated'),
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('messages.error'),
            detail: this.translate.instant('responses.' + message['message']),
            life: 20000,
            sticky: true,
          });
        }
        this.handleShopInfo(this.shopCode);
      },
      error: (message) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('messages.errorSummary'),
        });
      },
    });
  }

  openUpdateUserDialog(user = null) {
    let data = { shop: this.shopInfo };
    if (user != null) data['user'] = user;
    this.ref = this.dialogService.open(AddUserDialogComponent, {
      header: user === null ? this.translate.instant('shop.addUser') : this.translate.instant('shop.updateUser'),
      data: { ...data },
      width: '42vw',
      height: '80vh',
      modal: true,
      breakpoints: {
        '1200px': '50vw',
        '960px': '60vw',
        '640px': '80vw',
      },
    });
    this.ref.onClose.subscribe({
      next: (response) => {
        if (response) {
          if (user) {
            this.updateUser(response);
          } else {
            this.addUser(response);
          }
        }
      },
    });
  }

  openEditStatusUserDialog(user, status) {
    let msg = this.translate.instant('shop.disableUserMessage').replace('%name', user.name);
    if (status == 'enable') {
      msg = this.translate.instant('shop.enableUserMessage').replace('%name', user.name);
    }
    this.confirmationService.confirm({
      header: this.translate.instant('messages.areYouSure'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translate.instant('global.yes'),
      rejectLabel: this.translate.instant('global.no'),
      rejectButtonStyleClass: 'p-button-outlined',
      message: msg,
      accept: () => {
        this.disableEnableUser(user, status);
      },
      reject: () => {},
    });
  }

  updateUser(user) {
    user.isSeller = this.userService.isDefaultSeller(user);
    delete user.password;
    user.defaultLanguage = user.language;
    const userData = {
      email: user?.email,
      firstname: user?.firstname,
      lastname: user?.lastname,
      shopCode: user.defaultShop?.shopCode,
      roleCode: user.defaultRole?.roleCode,
      shopName: user.defaultShop?.shopName,
      channelCode: user.defaultChannel?.channelCode,
      defaultLanguage: user.defaultLanguage,
      phoneNumber: user?.phoneNumber,
      isSeller: user.isSeller,
    };
    this.userService.updateShopUser(userData).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('messages.success'),
          detail: this.translate.instant('messages.updateSuccess'),
        });
        this.handleShopInfo(this.shopCode);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('messages.errorSummary'),
        });
      },
    });
  }

  disableEnableUser(user, status) {
    let detail = this.translate.instant('alerts.disabledUserMessage');
    if (status == 'enable') {
      detail = this.translate.instant('alerts.enabledUserMessage');
    }
    this.userService.disableEnableUser({ email: user.email, shopCode: this.selectedShop.shopCode }).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('messages.success'),
          detail: detail,
          life: 3000,
        });
        this.handleShopInfo(this.shopCode);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('messages.errorSummary'),
          life: 3000,
        });
      },
    });
  }

  getSeverity(status) {
    return Util.getSeverity(status);
  }

  importModelChange() {
    this.importOutlined = false;
  }

  openAssociateAgregatorDialog() {
    this.shopService.getAllAggregators(this.shopCode).subscribe({
      next: (res: Aggregator[]) => {
        this.allAggregators = res;
      },
    });
    this.showAssociateDialog = true;
  }

  openChangeAssociationDialog(aggregator, associate) {
    this.selectedAggregator = aggregator;
    let message;
    if (associate) {
      message = this.translate.instant('shop.aggregatorActivationConfirmation').replace('%name', aggregator.name);
    } else {
      message = this.translate.instant('shop.aggregatorDeactivationConfirmation').replace('%name', aggregator.name);
    }
    this.confirmationService.confirm({
      header: this.translate.instant('messages.areYouSure'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translate.instant('global.yes'),
      rejectLabel: this.translate.instant('global.no'),
      rejectButtonStyleClass: 'p-button-outlined',
      message: message,
      accept: () => {
        this.associateAgregator(associate);
      },
      reject: () => {},
    });
  }

  hideChangeAssociationDialog() {
    this.showChangeAssociationDialog = false;
    this.selectedAggregator = null;
  }

  associateAgregator(associate) {
    const data = {
      shopCode: this.shopCode,
      aggregatorCode: this.selectedAggregator.aggregatorCode,
      isAssociated: associate,
    };
    this.shopService.associateAggregator(data).subscribe({
      next: () => {
        this.showAssociateDialog = false;
        this.selectedAggregator = null;
        this.showChangeAssociationDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('messages.success'),
          detail: this.translate.instant('messages.updateSuccess'),
          life: 3000,
        });
        this.handleShopInfo(this.selectedShop.shopCode);
        this.initUserAggregators(this.selectedShop.shopCode);
      },
      error: () => {
        this.selectedAggregator = null;
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('messages.errorSummary'),
          life: 3000,
        });
      },
    });
  }

  exportShopUsers() {
    this.shopService.exportUsers({shopCode: this.shopCode }).subscribe({
      next: (response) => Util.handleExportSuccess(response),
      error: Util.handleExportError,
    })
  }

  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }

  hiddenValue(user) {
    return this.user.email == user.email;
  }

  onTabChange(value) {
    this.activeTabIndex = typeof value === 'number' ? value : value?.index;
  }
}
